<template>
    <report-list-view downloadable filterable>
        <template slot="tableColumns">
            <veui-table-column field="id" title="卡片名称/ID">
                <template slot-scope="props">
                    <veui-span>
                        {{props.item.name}}
                        <br>
                        {{props.item.id || props.item.instanceId}}
                    </veui-span>
                </template>
            </veui-table-column>
            <veui-table-column field="previewUrl"
                title="卡片缩略图"
                width="140">
                <template slot-scope="props">
                    <div class="img-container" :style="{backgroundImage: `url(${https(props.item.previewUrl)})`}"/>
                </template>
            </veui-table-column>
            <veui-table-column field="aderName" title="广告主">
                <template slot-scope="props">
                    <div class="pre-wrap">{{props.item.aderName}}</div>
                </template>
            </veui-table-column>
            <veui-table-column field="statusLabel" title="状态" width="90">
                <template slot-scope="props">
                    <veui-span :class="props.item.statusColor">
                        {{props.item.statusLabel}}
                    </veui-span>
                </template>
            </veui-table-column>
            <veui-table-column field="clickThrough" title="跳转点击量" width="90"/>
            <veui-table-column field="clickThroughRatioPercent" title="跳转点击率" width="90"/>
            <veui-table-column field="interactClick" title="交互点击量" width="90"/>
            <veui-table-column field="interactClickRatioPercent" title="交互点击率" width="90"/>
            <veui-table-column field="operation" title="其他" width="110">
                <template slot-scope="props">
                    <veui-button ui="link primary"
                        @click="showHeatmapDialog(props.item.id, props.item.name)">组件点击率
                    </veui-button>
                    <veui-button ui="link"
                        @click="showTrend(`${props.item.id}`, `${props.item.name}—趋势曲线`)">
                        趋势曲线<veui-icon name="eye"/>
                    </veui-button>
                </template>
            </veui-table-column>
        </template>

        <template slot="after">
            <report-chart-dialog :open.sync="chartDialogVisible"
                :title="chartName"
                :chart-data="this.store.trendData"
                report-type="interact"/>

            <veui-dialog :open.sync="heatMapDialogVisible"
                :title="heatmapDialogTitle"
                overlay-class="heatmap-preview-dialog">
                <veui-switch @change="toggleLinkHeatmap" :checked.sync="showHeatmapMask">
                    显示点击率
                    <veui-span ui="micro">(点击率=点击数/展现数）× 100%</veui-span>
                </veui-switch>
                <ria-iframe ref="heatmap"
                    :class="iframeClass"
                    @loaded="iframeLoaded = true"
                    :auto-width="false"
                    :auto-height="false"
                    :content-html="this.contentHtml || ''"/>
                <div slot="foot"/>
            </veui-dialog>
        </template>
    </report-list-view>
</template>

<script>
import Model from './ListModel';
import 'veui-theme-one-icons/eye';
import {httpsTransform} from '@/common/utils';
import Iframe from '@baidu/ve-ria/components/Iframe';
import ReportListView from '../common/ReportListView';
import createView from '@baidu/ve-ria/views/createView';
import ReportChartDialog from '../common/ReportChartDialog';
import {Column, Button, Span, Dialog, Switch, Icon} from 'veui';

export default createView(ReportListView, Model, {
    components: {
        ReportChartDialog,
        'veui-table-column': Column,
        'veui-button': Button,
        'veui-span': Span,
        'veui-icon': Icon,
        'veui-dialog': Dialog,
        'ria-iframe': Iframe,
        'veui-switch': Switch
    },
    computed: {
        iframeClass() {
            return this.iframeLoaded ? 'iframe-ready' : 'iframe-loading';
        }
    },
    data() {
        return {
            chartDialogVisible: false,
            chartName: '',
            heatMapDialogVisible: false,
            heatmapDialogTitle: '',
            iframeLoaded: false,
            contentHtml: '',
            showHeatmapMask: true
        };
    },
    methods: {
        async showHeatmapDialog(id, cardName) {
            let data = await this.store.requestHeatMapData(id);
            this.contentHtml = this.store.genHeatMapMaterialHTML(data);
            this.heatMapDialogVisible = true;
            this.heatmapDialogTitle = cardName;

            if (!this.showHeatmapMask) {
                // 上一次关闭dialog如果隐藏了mask, 这里重置下。确保每次打开dialog都显示mask。
                this.showHeatmapMask = true;
                this.toggleLinkHeatmap(this.showHeatmapMask);
            }
        },
        async showTrend(id, name) {
            await this.store.requestTrendData({id});
            this.chartDialogVisible = true;
            this.chartName = name;
        },
        toggleLinkHeatmap(checked) {
            let action = checked ? 'showmask' : 'hidemask';
            // ve-ria bug不能直接使用 this.$refs.heatmap.postMessage
            this.$refs.heatmap.$refs.iframe.contentWindow.postMessage(JSON.stringify({action}), '*');
        },
        https(value) {
            return httpsTransform(value);
        }
    }
});
</script>

<style lang="less">
@import '~veui-theme-one/lib.less';
.heatmap-preview-dialog {
    .veui-dialog-content {
        width: 530px;
        height: 560px;
    }

    .veui-switch {
        margin-bottom: 20px;
        .veui-span {
            color: @veui-text-color-weak;
        }
    }

    iframe {
        height: 400px;
        width: 490px
    }
    .iframe-ready {
        opacity: 1;
    }
    .iframe-loading {
        opacity: 0;
    }
}
</style>

